// Normalizadores de empresa/obra/contato usados nas telas de relatório (seleção de filtros).

// Normaliza uma empresa da API para { id, nome, idUsuarioAssinatura1, idUsuarioAssinatura2 }.
export function normalizeEmpresa(item) {
  return {
    id: String(item.idEmpresa || item.id || ''),
    nome: item.razaoSocial || item.nomeEmpresa || item.nome || '-',
    idUsuarioAssinatura1: String(item.idUsuarioAssinatura1 || item.id_usuario_assinatura_1 || item.usuarioAssinatura1?.idUsuario || ''),
    idUsuarioAssinatura2: String(item.idUsuarioAssinatura2 || item.id_usuario_assinatura_2 || item.usuarioAssinatura2?.idUsuario || ''),
  };
}

// Normaliza uma obra da API para { id, nome, idEmpresa, idContatoTecnico }.
export function normalizeObra(item) {
  return {
    id: String(item.idObra || item.id || ''),
    nome: item.nomeObra || item.nome || '-',
    idEmpresa: String(item.idEmpresa || item.empresa?.idEmpresa || ''),
    idContatoTecnico: String(
      item.idContatoTecnico || item.contatoTecnico?.idContato || item.ContatoTecnico?.IdContato || ''
    ),
  };
}
